import type { ISerialize } from '@/objects/ISerialize';

export class EventLocation implements ISerialize {
    public CountryISO3: string | null;

    public Latitude: number | null;

    public Longitude: number | null;

    public Name: string | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { CountryISO3?: string | null; Latitude?: number | null; Longitude?: number | null; Name?: string | null }) {
        this.CountryISO3 = values.CountryISO3 ?? null;

        this.Latitude = values.Latitude ?? null;

        this.Longitude = values.Longitude ?? null;

        this.Name = values.Name ?? null;
    }

    public serialize(): string {
        return (
            '{' +
            `"CountryISO3": ${JSON.stringify(this.CountryISO3)}` +
            ',' +
            `"Latitude": ${JSON.stringify(this.Latitude)}` +
            ',' +
            `"Longitude": ${JSON.stringify(this.Longitude)}` +
            ',' +
            `"Name": ${JSON.stringify(this.Name)}` +
            '}'
        );
    }

    /**
     * Creates an instance of EventLocation from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        CountryISO3?: string | null;
        Latitude?: number | null;
        Longitude?: number | null;
        Name?: string | null;
    }): EventLocation {
        return new EventLocation(values);
    }

    public static _FromServerJson(json: any): EventLocation {
        return new EventLocation({
            CountryISO3: json.CountryISO3 ?? '',
            Latitude: json.Latitude ?? null,
            Longitude: json.Longitude ?? null,
            Name: json.Name ?? '',
        });
    }

    /**
     * Creates an instance of EventLocation from another instance of EventLocation.
     * @param other The EventLocation you want to clone
     * @returns A cloned EventLocation
     */
    public static FromOther(other: EventLocation): EventLocation {
        return EventLocation._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return EventLocation.FromOther(this);
    }

    static NAME_OF_CLASS = 'EventLocation';
}
